
import { supabase } from '@/integrations/supabase/client';
import { User } from '@/types/chat';

export const supabaseUserSearchService = {
  // Search users (for adding to groups)
  async searchUsers(query: string): Promise<User[]> {
    console.log('=== SUPABASE USER SEARCH ===');
    console.log('Searching users via Supabase:', query);
    
    if (!query || query.trim().length < 1) {
      return [];
    }

    // Clean the query
    const cleanQuery = query.trim();

    const { data, error } = await supabase
      .from('profiles')
      .select('id, username, first_name, last_name, role')
      .or(`username.ilike.%${cleanQuery}%,first_name.ilike.%${cleanQuery}%,last_name.ilike.%${cleanQuery}%`)
      .limit(20);

    if (error) {
      console.error('Error searching Supabase users:', error);
      return [];
    }

    const users: User[] = data.map(user => ({
      id: user.id,
      username: user.username || user.first_name || 'Unknown User',
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      role: user.role,
      user_type: 'supabase' as const
    }));

    console.log('Supabase search results:', users.length);
    users.forEach(user => {
      console.log(`Supabase user: ${user.username} (${user.id})`);
    });

    return users;
  },

  // Get all users (for adding to groups)
  async getAllUsers(): Promise<User[]> {
    console.log('=== SUPABASE GET ALL USERS ===');
    console.log('Getting all users via Supabase');
    
    const { data, error } = await supabase
      .from('profiles')
      .select('id, username, first_name, last_name, role')
      .limit(200);

    if (error) {
      console.error('Error fetching Supabase users:', error);
      return [];
    }

    const users: User[] = data.map(user => ({
      id: user.id,
      username: user.username || user.first_name || 'Unknown User',
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      role: user.role,
      user_type: 'supabase' as const
    }));

    console.log('Supabase all users fetched:', users.length);
    return users;
  }
};
